// api.js
import { supabase } from '../supabaseClient';

// Utility function for authenticated API calls
export const authenticatedFetch = async (url, options = {}) => {
  const { data: { session } } = await supabase.auth.getSession();
  
  if (!session?.access_token) {
    throw new Error('No active session found');
  }

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${session.access_token}`,
    ...options.headers,
  };

  return fetch(url, {
    ...options,
    headers,
  });
};

// API to insert a new lawyer
export const insertLawyer = async (lawyerData) => {
  try {
    const { data, error } = await supabase
      .from('lawyers') // Your table name
      .insert([lawyerData]);

    if (error) throw error;
    return data;
  } catch (error) {
    console.error('Error inserting lawyer data:', error);
    throw error;
  }
};

// API to insert a new client
export const insertClient = async (clientData) => {
  try {
    const { data, error } = await supabase
      .from('clients') // Your table name
      .insert([clientData]);

    if (error) throw error;
    return data;
  } catch (error) {
    console.error('Error inserting client data:', error);
    throw error;
  }
};

// API to insert a new admin
export const insertAdmin = async (adminData) => {
  try {
    const { data, error } = await supabase
      .from('admins') // Your table name
      .insert([adminData]);

    if (error) throw error;
    return data;
  } catch (error) {
    console.error('Error inserting admin data:', error);
    throw error;
  }
};

// You can add more APIs for other tables as needed.

export const fetchLawyerData = async (userId) => {
  try {
    const { data, error } = await supabase
      .from('lawyers') // Replace with your actual table name
      .select('*')
      .eq('user_id', userId); // Assuming user_id is the identifier for fetching specific lawyer data

    if (error) throw error;
    return data[0]; // Assuming each user_id is unique, so we return the first item
  } catch (error) {
    console.error('Error fetching lawyer data:', error);
    throw error;
  }
};